
module.exports = () => {
    document.addEventListener('wpcf7mailsent', function(event) {
        const form = event.target;
        const section = form.closest('.contact_form');
        if (!section) return;

        const formContainer = section.querySelector('.form-container');
        const thankYou = section.querySelector('.thank-you-message');

        if (formContainer && thankYou) {
            formContainer.style.display = 'none';
            thankYou.style.display = 'block';
        }
    });
}
